module.exports = __webpack_public_path__ + "static/media/comprehensive.aa83cbd4.png";